import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  Dropdown,
  DropdownMenuHeader,
  DropdownMenuItem,
  DropdownMenuDivider
} from '@bibliocommons/deprecated-base-dropdown';
import { fixedEncodeURIComponent } from 'app/helpers/url';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import { didNotFindOptionsShape } from '@bibliocommons/bc-prop-types';

import ExternalSearchLink from '../ExternalSearchLink';

import './DidNotFindDropdown.scss';

function injectQueryIntoUrl(query, url) {
  return query && url ? url.replace(/{query}/gi, fixedEncodeURIComponent(query)) : url;
}

export default class DidNotFindDropdown extends React.PureComponent {
  renderResourceLink(linkText, url) {
    return (
      <a
        className="did-not-find-link"
        href={injectQueryIntoUrl(this.props.query, url)}
        rel="noopener noreferrer"
        target="_blank"
      >
        <span aria-hidden>{linkText}</span>
        <ScreenReaderMessage>
          <FormattedMessage id="ada_opens_a_new_tab" values={{ linkText }} />
        </ScreenReaderMessage>
      </a>
    );
  }

  renderExternalSearchLink() {
    const { query, searchType } = this.props;

    return (
      <DropdownMenuItem key="external-link-item">
        <ExternalSearchLink query={query} searchType={searchType} />
      </DropdownMenuItem>
    );
  }

  renderResourceLinksMenu() {
    const { showExternalSearchLink, searchType } = this.props;

    const resourceLinkMenuHeader = (
      <DropdownMenuHeader key="resource-link-menu-header">
        <FormattedMessage id="more_resources" />
      </DropdownMenuHeader>
    );

    const resourceLinkMenuItems = this.props.didNotFindOptions
      .get('didNotFindResources')
      .map(resource => (
        <DropdownMenuItem key={`did-not-find-link-${resource.get('resourceName').toLowerCase()}`}>
          {this.renderResourceLink(resource.get('resourceName'), resource.get('resourceLink'))}
        </DropdownMenuItem>
      ));

    const menuDivider = <DropdownMenuDivider key="did-not-find-resource-links-divider" />;

    const externalSearchLink =
      showExternalSearchLink && searchType !== 'bl' ? [this.renderExternalSearchLink(), menuDivider] : null;

    return [externalSearchLink, resourceLinkMenuHeader, resourceLinkMenuItems];
  }

  render() {
    return (
      <div className="cp-did-not-find-dropdown">
        <Dropdown
          dataKey="did-not-find-dropdown"
          selected={<FormattedMessage id="search_other_resources" />}
          className="btn btn-link"
        >
          {this.renderResourceLinksMenu()}
        </Dropdown>
      </div>
    );
  }
}

DidNotFindDropdown.propTypes = {
  query: PropTypes.string,
  searchType: PropTypes.string,
  didNotFindOptions: didNotFindOptionsShape,
  showExternalSearchLink: PropTypes.bool
};
